// extracted by mini-css-extract-plugin
export default {"overview__buttons":"styles_overview__buttons__f-PzW","__react_component_tooltip":"styles___react_component_tooltip__-m4WF"};